import {ReactElement, useEffect, useState} from 'react';
import {textFieldStyles} from '../../TableDataAndStyles';
import {makeStyles} from '@material-ui/core';
import {APP, DEFAULT_BLACK_COLOR} from 'src/style/variable';
import {useDispatch, useSelector} from 'react-redux';
import {useSnackbar} from 'notistack';
import {fetchGuarantorInvoices} from '@shared/services/DueInvoiceServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {_patientDrawerDetails} from '@shared/store/actions/PatientDrawerAction';
import Loader from '@components/framework/loader/Loader';
import MaterialTable from 'material-table';
// table cells, headers, table box shadow, border, background styles
import {
  BorderAndBackgroundColor,
  DetailsPanelTableBoxShadow,
  tableCellWidth12,
  tableCellWidth15,
  tableCellWidth8
} from '../../TableStyles';
import React from 'react';
import HelperUtils from '@shared/utils/HelperUtils';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
export const FilterClinicStyles = makeStyles(() => ({
  gridText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  loaderStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
interface GuarantorInvoicesProps {
  guarantorId: number;
}

const GuarantorInvoicesTable = (
  props: GuarantorInvoicesProps
): ReactElement => {
  const classes = textFieldStyles();
  const ClinicClasses = FilterClinicStyles();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const {enqueueSnackbar} = useSnackbar();
  const {guarantorId} = props;
  const groupId: any = useSelector((state: any) => state.auth.groupId);

  const acOfClinics: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const [invoiceData, setInvoiceData] = useState([]);

  const getGuarantorInvoices = async () => {
    try {
      const response = await fetchGuarantorInvoices(
        groupId,
        acOfClinics?.[0],
        guarantorId
      );
      setInvoiceData(response?.data?.rows || []);
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // ** Guarantor Invoices API is being called when the panel is opened */
    getGuarantorInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const openDrawer = (
    // eslint-disable-next-line no-shadow
    groupId: number,
    selectedClinicId: number,
    patientId: number
  ): void => {
    //* setting up the patient paramters in redux to open patoent details drawer
    const _clinicId = Array.isArray(selectedClinicId)
      ? selectedClinicId?.[0]
      : selectedClinicId;
    dispatch(_patientDrawerDetails(groupId, _clinicId, patientId));
  };
  return (
    <div id="due_detailed_panel">
      {isLoading ? (
        <div className={ClinicClasses.loaderStyle}>{<Loader />}</div>
      ) : (
        <MaterialTable
          columns={[
            {
              title: '',
              field: 'first',
              cellStyle: {
                ...tableCellWidth12,
                ...BorderAndBackgroundColor
              }
            },
            {
              title: 'Patient Name',
              field: 'patients',
              render: (rowData: any) => {
                return (
                  <div
                    data-test-id="pcl-copayChargesComponent-openPatientDrawer"
                    className={[
                      classes.primaryTextColor,
                      classes.patientNameStyles,
                      ClinicClasses.gridText
                    ].join(' ')}
                    onClick={(): void => {
                      return openDrawer(
                        groupId,
                        acOfClinics,
                        rowData?.patient_id
                      );
                    }}>
                    {HelperUtils.commaSeparatedFullName(
                      rowData.first_name,
                      rowData.last_name,
                      rowData.middle_name
                    )}
                  </div>
                );
              },
              cellStyle: {
                ...tableCellWidth15,
                ...BorderAndBackgroundColor
              }
            },
            {
              title: 'Account#',
              field: 'emr',
              cellStyle: {
                ...tableCellWidth12,
                ...BorderAndBackgroundColor
              }
            },
            {
              title: 'Visited On',
              field: 'visit',
              cellStyle: {
                ...tableCellWidth15,
                ...BorderAndBackgroundColor
              },
              render: (rowData: any) => {
                return (
                  <div>{HelperUtils.formatDisplayDate(rowData.visited_on)}</div>
                );
              }
            },
            {
              title: 'Clinic',
              field: 'clinic_name',
              render: (rowData: any) => {
                return (
                  <div className={ClinicClasses.gridText}>
                    {rowData.clinic_name}
                  </div>
                );
              },
              cellStyle: {
                ...tableCellWidth15,
                ...BorderAndBackgroundColor
              }
            },
            {
              title: 'Amount Due',
              field: 'due_amount',
              render: (rowData: any) => {
                return (
                  <div>
                    <CurrencyFormatter
                      value={rowData.due_amount}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      ignoreRound={true}
                      useSign={true}
                    />
                  </div>
                );
              },
              cellStyle: {
                ...tableCellWidth8,
                ...BorderAndBackgroundColor
              },
              align: 'right'
            },
            {
              title: 'Statement Date',
              field: 'invoice_date',
              render: (rowData: any) => {
                return (
                  <div>
                    {HelperUtils.formatDisplayDate(rowData.invoice_date)}
                  </div>
                );
              },
              cellStyle: {
                ...BorderAndBackgroundColor
                // fontSize: '0.875rem'
              }
            }
          ]}
          data={invoiceData}
          options={{
            search: false,
            showTitle: false,
            toolbar: false,
            paging: false,
            sorting: false,
            draggable: false,
            headerStyle: {
              color: DEFAULT_BLACK_COLOR,
              fontFamily: APP.FONT_FAMILY.MEDIUM,
              ...BorderAndBackgroundColor,
              fontSize: '1rem'
            }
          }}
          style={{
            boxShadow: DetailsPanelTableBoxShadow
          }}
        />
      )}
    </div>
  );
};

export default GuarantorInvoicesTable;
